import React from 'react';
import SvgIcon from './SvgIcon';

const CheckBoxFull = props => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M22.5.499h-21a1 1 0 00-1 1v21a1 1 0 001 1h21a1 1 0 001-1v-21a1 1 0 00-1-1z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M18 6.999l-7 9.5-5-4" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        </SvgIcon>
    );
};

CheckBoxFull.displayName = 'CheckBoxFullIcon';

export default CheckBoxFull;
